import React from "react";
import { Grid, TextField, Select, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiInput-underline:before": {
      borderBottomColor: "#ddd",
    },
  },
}));
function PercentageColumnOptions({
  values: {
    options: {
      number_format: numberFormat = "",
      max_value: maxValue = "",
      min_value: minValue = "",
      decimals = 2,
    },
  },
  valuesPath = "",
  handleChange,
  setFieldValue,
  isOnlyFormattingConfig,
  isAdditionalOptions,
}) {
  const classes = useStyles();
  React.useEffect(() => {
    if (numberFormat !== "") {
      return;
    }
    setFieldValue(`${valuesPath}options.number_format`, "10000");
  }, [setFieldValue, numberFormat, valuesPath]);

  return (
    <React.Fragment>
      <Grid item container xs={12}>
        Comma Format
        <Grid item xs={12}>
          <Select
            name={`${valuesPath}options.number_format`}
            value={numberFormat}
            onChange={handleChange}
            variant="outlined"
            style={{ width: 200 }}
          >
            <MenuItem value={"10000"}>10000</MenuItem>
            <MenuItem value={"100,000,000"}>100,000,000</MenuItem>
            <MenuItem value={"10,00,000"}>10,00,000</MenuItem>
          </Select>
        </Grid>
      </Grid>
      <Grid item container>
        <Grid item container>
          <Grid item xs={6}>
            Decimal Places:
          </Grid>
          <TextField
            type="number"
            className={classes.root}
            name={`${valuesPath}options.decimals`}
            value={decimals}
            inputProps={{
              min: "0",
            }}
            onInput={(event) => {
              event.target.value =
                !isNaN(Number(event.target.value)) && event.target.value >= 0
                  ? event.target.value
                  : "";
            }}
            onChange={handleChange}
            size="small"
            style={{ maxWidth: 50 }}
          />
        </Grid>
      </Grid>
      <Grid item container>
        For e.g., {getPreviewFormat(numberFormat, decimals)} %
      </Grid>
      {!isOnlyFormattingConfig && isAdditionalOptions && (
        <>
          <Grid item container>
            <Grid item xs={6}>
              Max Value:
            </Grid>
            <TextField
              variant="outlined"
              name={`${valuesPath}options.max_value`}
              value={maxValue}
              onChange={handleChange}
              size="small"
              style={{ maxWidth: 50 }}
              type="number"
              inputProps={{
                min: "0",
              }}
              onInput={(event) => {
                event.target.value =
                  !isNaN(Number(event.target.value)) && event.target.value >= 0
                    ? event.target.value
                    : "";
              }}
            />
          </Grid>
          <Grid item container>
            <Grid item xs={6}>
              Min Value:
            </Grid>
            <TextField
              variant="outlined"
              name={`${valuesPath}options.min_value`}
              value={minValue}
              onChange={handleChange}
              size="small"
              style={{ maxWidth: 50 }}
              type="number"
              inputProps={{
                min: "0",
              }}
              onInput={(event) => {
                event.target.value =
                  !isNaN(Number(event.target.value)) && event.target.value >= 0
                    ? event.target.value
                    : "";
              }}
            />
          </Grid>
        </>
      )}
    </React.Fragment>
  );
}

const getPreviewFormat = function (format, decimal) {
  decimal = parseInt(decimal);
  if (decimal < 0 || isNaN(decimal)) decimal = 0;

  let num = 12345,
    div = Math.pow(10, decimal),
    previewNum = num / div,
    formatNumber = "";

  if (format === "10000") {
    formatNumber = "12345";
  } else if (format === "10,00,000") {
    formatNumber = "12,34,567";
  } else if (format === "100,000,000") {
    formatNumber = "1,234,567";
  }
  if (typeof previewNum.toString().split(".")[1] == "undefined") {
    return formatNumber;
  }
  return formatNumber + "." + previewNum.toString().split(".")[1];
};
export default PercentageColumnOptions;
